var m = require('mithril');
var prop = require('mithril/stream');
var dragscroll = require('../../libs/dragscroll');
var auth = require('../../auth/models/session');
var equipmentClassToDisplayName = require('../../libs/equipmentClassToDisplayName');
var key = require('../../libs/keybindings');
var loaders = require('../../layout/components/loaders');
var edit = require('../../layout/components/edit');
var modal = require('../../layout/components/modal');
var alerts = require('../../layout/components/alerts');
var header = require('../../layout/components/header');
var modelDetail = require('../../components/modelDetail');
var modelActions = require('./modelActions');
var hoverableDropdownDiv = require('../../components/hoverableDropdownDiv');
var paginationWithSearch = require('../../data/components/paginationWithSearch');
var rowActionDropdown = require('../../components/rowActionDropdown');
var networkTreeTransferModal = require('../treeTransferModal');
var tableColumns = require('./tableColumns');
var bacnetPresentation = require('../../bacnet/deviceDiscoveryPresentation');
var pageTitle = require('../../layout/pageTitle');
var requestState = require('../requestState');

var STATUSES = ['ok', 'unknown', 'warning', 'error'];
var LOCATION_CLASSES = [
  'Site',
  'Building',
  'Floor',
  'Room',
];
var CLASSES_WITH_DIRECT_LINKS = ['Dashboard'].concat(LOCATION_CLASSES);
var CLASSES_WITH_NO_LINKS = [
  'Element',
  'Dataset',
  'Point',
  'Column'
];
var TREE_TRANSFER_MENU_LABELS = {
  BacnetServer: 'BACnet Devices',
  ModbusTcp: 'Modbus Devices',
  RestHttp: 'REST Resources',
  LontalkCnip: 'LonTalk Networks'
};
var BACNET_DEVICE_FIELDS = [
  'name',
  'objectId',
  'network',
  'address',
  'addressBytes',
  'vendorId',
  'maxApdu',
  'segmentation',
  'lastDiscoveredAt'
];
var BACNET_DEVICE_LABELS = {
  name: 'Device Name',
  objectId: 'Device Instance',
  network: 'Source Network',
  address: 'Source Address',
  addressBytes: 'Address Bytes',
  vendorId: 'Vendor ID',
  maxApdu: 'Maximum APDU',
  segmentation: 'Segmentation',
  lastDiscoveredAt: 'Last Discovered'
};

var page = {};

page.oninit = function (vnode) {
  var ctrl = this;
  ctrl.recordModel = vnode.attrs.recordModel;
  ctrl.form = vnode.attrs.form;
  ctrl.newNode = prop(false);
  ctrl.usedOnPaths = prop([]);
  ctrl.usedOnNewNode = prop(false);
  ctrl.usedOnToShow = [];
  ctrl.usedOnFilteredLength = prop(null);
  ctrl.usedOnResource = prop(null);
  ctrl.usedOnLoading = prop(false);
  ctrl.openDropdownId = prop(null);
  ctrl.selectedChildRids = {};
  ctrl.trafficPolicy = null;
  requestState.initialize(ctrl);

  pageTitle.set(null, { fallback: ctrl.recordModel.name });
  header.vm.activeTab(vnode.attrs.activeTab);

  ctrl.toggleDropdown = function (menuId) {
    ctrl.openDropdownId(ctrl.openDropdownId() === menuId ? null : menuId);
  };

  ctrl.handleDropdownMouseOver = function (menuId) {
    ctrl.openDropdownId(menuId);
  };

  ctrl.handleDropdownMouseOut = function () {
    ctrl.openDropdownId(null);
  };

  ctrl.fetchUsedOn = function () {
    const rid = (ctrl.record && ctrl.record['@rid']) ? ctrl.record['@rid'].slice(1) : m.route.param('id');
    ctrl.usedOnLoading(true);
    ctrl.usedOnPaths([]);
    ctrl.usedOnToShow.length = 0;
    ctrl.usedOnFilteredLength(null);
    ctrl.usedOnNewNode(true);
    return loaders.requestWithLoader({
      url: `/api/v1/host/${rid}/connections`,
      method: "GET",
      background: true
    })
      .then(function (result) {
        ctrl.usedOnResource(result);
        var formatted = formatUsedOnRecords((result && result.usedOn) || []);
        ctrl.usedOnPaths(formatted);
        ctrl.usedOnNewNode(true);
      })
      .catch(function () {
        ctrl.usedOnPaths([]);
        ctrl.usedOnNewNode(true);
      })
      .finally(function () {
        ctrl.usedOnLoading(false);
      });
  };

  ctrl.init = function () {
    return requestState.run(ctrl, function () {
      return loaders.requestWithLoader({
        url: "/api/v1/" + ctrl.recordModel.url + '/' + m.route.param('id'),
        method: "GET"
      })
        .then(function (res) {
          ctrl.record = res;
          pageTitle.set(ctrl.record, { fallback: ctrl.recordModel.name });
          ctrl.record.children = res.children.filter(child => child.deleted != true)
          ctrl.sort();
          pruneSelectedChildren(ctrl);
          ctrl.newNode(true);
          var trafficRequest = ctrl.record['@class'] === 'BacnetServer'
            ? loaders.requestWithLoader({
              url: '/api/v1/bacnetserver/' + String(ctrl.record['@rid']).replace(/^#/, '') + '/traffic-policy',
              method: 'GET',
              loader: 'background'
            }).then(function (policy) {
              ctrl.trafficPolicy = policy;
            }).catch(function () { ctrl.trafficPolicy = null; })
            : Promise.resolve();
          return Promise.all([ctrl.fetchUsedOn(), trafficRequest]);
        });
    });
  };

  ctrl.sort = function () {
    ctrl.record.children.sort(sortByStatus);
    m.redraw();
  };

  modal.on('closed', ctrl.init);

  ctrl.init();
  ctrl.childrenToShow = [];
};

page.onremove = function () {
  modal.off('closed', this.init);
};

page.view = function () {
  var ctrl = this
  var stateView = requestState.view(ctrl);
  if (stateView) return stateView;
  if (!ctrl.record) {
    return m('div')
  }
  var isTreeTransferHost = ctrl.record && ['BacnetServer', 'ModbusTcp', 'RestHttp', 'LontalkCnip'].indexOf(ctrl.record['@class']) >= 0;
  var transferLabel = TREE_TRANSFER_MENU_LABELS[ctrl.record['@class']] || 'Nodes';
  var gateway = ctrl.record.breadcrumbs[0]
  var networkOverviewUrl = gateway['@id'].split('/').slice(3, 4).join('/').toLowerCase();
  var networkOverviewName = gateway['@class'].replace(/([A-Z])/g, ' $1');
  var showNetworkOverview = ['BacnetServer', 'ModbusTcp', 'RestHttp', 'LontalkCnip'].indexOf(gateway['@class']) === -1;
  var extraDetails = {
    nextPoll: gateway.nextPoll
  };
  if (ctrl.trafficPolicy && ctrl.trafficPolicy.policy) {
    var policy = ctrl.trafficPolicy.policy;
    extraDetails.trafficHandling = {
      label: 'Effective Traffic Handling',
      value: policy.profile === 'legacy'
        ? 'Existing traffic setting (compatibility) · ' + ctrl.trafficPolicy.rolloutMode
        : policy.profile.charAt(0).toUpperCase() + policy.profile.slice(1) +
          ' · ' + policy.concurrentDownstreamNetworks + ' downstream networks · ' +
          policy.requestSpacingMs + ' ms spacing · ' + ctrl.trafficPolicy.rolloutMode
    };
  }

  return m('div', [
    m('div.mh3.mb3.pb2.bb.bw1.b--mid-gray.near-white.flex.justify-between.items-center.display', [
      m('div.pb2.f-subheadline.fw5', [
        m('div.dib-ns.mr2', [
          m(m.route.Link, { href: '/networks' }, 'Networks'),
          ' / '
        ]),
        showNetworkOverview ? m('div.dib-ns.mr2', [
          m(m.route.Link, { href: '/' + networkOverviewUrl }, networkOverviewName),
          ' / '
        ]) : null,
        m('div.dib-ns.mr2', ctrl.record.name)
      ]),
      (function () {
        if (edit.vm.editing() && auth.user().isSuperuser == 1) {
          return m(rowActionDropdown, {
            items: [
              {
                label: 'Edit ' + ctrl.recordModel.name,
                icon: 'ion-ios-compose',
                onclick: () => ctrl.recordModel.editDialogue(ctrl.record)
              },
              isTreeTransferHost ? {
                label: 'Import ' + transferLabel,
                icon: 'ion-upload',
                onclick: () => networkTreeTransferModal.openHostImportModal(ctrl.record, ctrl.init)
              } : null,
              isTreeTransferHost ? {
                label: 'Export ' + transferLabel,
                icon: 'ion-document-text',
                onclick: () => networkTreeTransferModal.openHostExportModal(ctrl.record, ctrl.record.children)
              } : null,
              {
                label: 'New ' + ctrl.form.name,
                icon: 'ion-plus',
                onclick: () => ctrl.form.editDialogue({ parent: ctrl.record['@rid'] }, { parentRecord: ctrl.record })
              }
            ].filter(Boolean)
          })
        }
      })(),
    ]),
    modelDetail(ctrl, ctrl.recordModel, extraDetails),
    modelActions(ctrl, ctrl.recordModel),
    renderUsedOnDropdown(ctrl),
    (() => {
      const name = ctrl.recordModel['@class'].replace(/([A-Z])/g, " $1").trim().split(" ")[0];
      return m('div.mh3.mv3.bw1.pv1.tc.f3.bb',
        equipmentClassToDisplayName(name, false) +
        (ctrl.recordModel['@class'] == 'RestHttp' ?
          ' Resources'
          :
          ctrl.recordModel['@class'] == 'LontalkCnip' ?
            ' Networks'
            :
            ' Devices'
        )
      )
    })(),
    m('div.cf', browse(ctrl)),
  ])
};

function formatUsedOnRecords(records) {
  return (records || []).map(function (record) {
    var labels = [];
    (record || []).forEach(function (path) {
      if (!path || !path['@class']) return;
      var isHome = path.name === 'root';
      var label = isHome ? 'Home' : path.name ? `${path.name} (${path['@class']})` : `${path['@class']}`;
      labels.push(label);
    });
    return {
      paths: record,
      searchLabel: labels.join(' / ')
    };
  });
}

function getUsedOnType(record) {
  if (!Array.isArray(record) || !record.length) return '---';
  var lastNode = record.slice().reverse().find(function (node) {
    return node && node['@class'];
  });
  if (!lastNode || !lastNode['@class']) return '---';
  if (lastNode['@class'] === 'Dashboard') return 'Dashboard';
  if (LOCATION_CLASSES.indexOf(lastNode['@class']) >= 0) return 'Location';
  return 'Equipment';
}

function renderUsedOnContent(ctrl) {
  var usedOn = ctrl.usedOnToShow;
  var totalEntries = (ctrl.usedOnPaths() || []).length;
  var totalFiltered = ctrl.usedOnFilteredLength ? ctrl.usedOnFilteredLength() : 0;

  if (ctrl.usedOnLoading() && (!usedOn || !usedOn.length)) {
    return m('div', [
      m('div.tc', [
        m('img', {
          src: '/images/loading-bars.svg',
          alt: 'Loading',
          style: { width: '3rem', height: 'auto' }
        })
      ])
    ]);
  }

  var hasResults = totalFiltered !== null ? totalFiltered > 0 : totalEntries > 0;
  if (!hasResults) {
    return m('div', [
      m('div.mv2', totalEntries > 0 ? 'No connections match your search.' : 'No linked records found.')
    ]);
  }

  return m('div', [
    m(paginationWithSearch, {
      data: ctrl.usedOnPaths(),
      dataToShow: ctrl.usedOnToShow,
      newNode: ctrl.usedOnNewNode,
      filteredDataLength: ctrl.usedOnFilteredLength,
      placeHolder: 'Search connections',
      itemsPerPage: 10,
      fieldsToSearch: ['searchLabel'],
      hideSearch: totalEntries <= 10
    }, [
      m('div.mv1.overflow-hidden', [
        m('div.dragscroll-container', {
          style: {
            minHeight: '286px'
          }
        }, [
          m('div.dragscroll.mega-menu-dragscroll', { oncreate: dragscroll }, [
            m('table.fw2.f4.w-100.pr4', { style: { minWidth: '400px' } }, [
              m('thead', [
                m('tr', [
                  m('th.br.tl.bt-0.bl-0.b--dotted.bw1.fw2', { style: { width: '80%' } }, 'Path'),
                  m('th.br.tl.bt-0.bl-0.b--dotted.bw1.fw2', { style: { width: '20%' } }, 'Type'),
                ])
              ]),
              m('tbody', usedOn.map(function (entry) {
                if (!entry || !entry.paths || !entry.paths.length) return null;
                var record = entry.paths;
                return m('tr', [
                  m('td.bb.tl.moon-gray.nowrap.w-80',
                    m('div.flex.items-center', [
                      record.map(function (path, index) {
                        if (!path || !path['@class'] || !path['@rid']) return null;

                        const className = path['@class'].toLowerCase();
                        const rid = path['@rid'].slice(1);
                        const isHome = path.name === 'root';
                        const label = isHome ? 'Home' : path.name ? `${path.name}` : `${path['@class']}`;
                        const locationClass = LOCATION_CLASSES.includes(path['@class']);
                        const isLast = index === record.length - 1;
                        const isNoLink = CLASSES_WITH_NO_LINKS.includes(path['@class']);
                        const hasUrl = !!path.url;

                        let linkEl;
                        if (CLASSES_WITH_DIRECT_LINKS.includes(path['@class'])) {
                          linkEl = m(m.route.Link, {
                            href: `/${locationClass ? 'location' : className}/${rid}`,
                            class: 'link dim blue'
                          }, label);
                        } else if (isNoLink) {
                          if (hasUrl) {
                            linkEl = m('a', { href: path.url, class: 'link dim blue' }, label);
                          } else {
                            linkEl = label;
                          }
                        } else {
                          linkEl = m(m.route.Link, {
                            href: `/equipment/${className}/${rid}`,
                            class: 'link dim blue'
                          }, label);
                        }

                        const postfix = isLast ? null : (
                          isNoLink ? ' - ' : ' / '
                        );

                        return m('span.mr1.nowrap.truncate', [
                          linkEl,
                          postfix && m('span', postfix)
                        ]);
                      })
                    ])

                  ),
                  m('td.bb.tl.moon-gray.nowrap.w-20', getUsedOnType(record)),
                ]);
              }))
            ])

          ])
        ])
      ])
    ])
  ]);
}

function renderUsedOnDropdown(ctrl) {
  var dropdownId = 'menu-usedon';
  var content = renderUsedOnContent(ctrl);

  return m('div.cf.ph3', [
    m('div.relative', [
      m(hoverableDropdownDiv, {
        menuTitle: 'Connections',
        menuId: dropdownId,
        mainDivClass: '.fr.w-100.w-50-ns.w-25-l.f6.mt3',
        isOpen: ctrl.openDropdownId() === dropdownId,
        toggleDropdown: ctrl.toggleDropdown,
        onMouseOver: () => ctrl.handleDropdownMouseOver(dropdownId),
        onMouseOut: ctrl.handleDropdownMouseOut,
        content: content,
        toggleButtonId: 'EquipmentUsedOnToggle',
        onupdate: function (vnode) {
          var toggleEl = document.getElementById(vnode.state.toggleButtonId);
          if (!toggleEl) return;

          toggleEl.classList.add('justify-between');
          toggleEl.classList.add('ml3-m');
          toggleEl.classList.add('ml-1_5-l');
        }
      })
    ])
  ]);
}

function recordRid(record) {
  return record && record['@rid'] ? String(record['@rid']) : '';
}

function childName(ctrl, count) {
  var name = ctrl.form.name || 'record';
  if (count === 1) return name;
  if (/s$/i.test(name)) return name + 'es';
  return name + 's';
}

function isChildSelected(ctrl, record) {
  var rid = recordRid(record);
  return !!(rid && ctrl.selectedChildRids && ctrl.selectedChildRids[rid]);
}

function selectableChildren(records) {
  return (records || []).filter(function (record) {
    return !!recordRid(record);
  });
}

function selectedChildRecords(ctrl) {
  return selectableChildren(ctrl.record && ctrl.record.children).filter(function (record) {
    return isChildSelected(ctrl, record);
  });
}

function visibleSelectedChildren(ctrl) {
  return selectableChildren(ctrl.childrenToShow).filter(function (record) {
    return isChildSelected(ctrl, record);
  });
}

function pruneSelectedChildren(ctrl) {
  var nextSelected = {};
  selectableChildren(ctrl.record && ctrl.record.children).forEach(function (record) {
    var rid = recordRid(record);
    if (ctrl.selectedChildRids && ctrl.selectedChildRids[rid]) {
      nextSelected[rid] = true;
    }
  });
  ctrl.selectedChildRids = nextSelected;
}

function setChildSelected(ctrl, record, selected) {
  var rid = recordRid(record);
  if (!rid) return;
  if (selected) {
    ctrl.selectedChildRids[rid] = true;
  } else {
    delete ctrl.selectedChildRids[rid];
  }
}

function setVisibleChildrenSelected(ctrl, selected) {
  selectableChildren(ctrl.childrenToShow).forEach(function (record) {
    setChildSelected(ctrl, record, selected);
  });
}

function renderChildSelectionButton(options) {
  var checked = !!options.checked;
  var mixed = !!options.mixed;
  var disabled = !!options.disabled;
  var label = options.label;
  var className = 'ba bw1 br1 flex items-center justify-center center';
  if (options.class) className += ' ' + options.class;

  return m('button', {
    type: 'button',
    class: className,
    style: {
      width: '1.35rem',
      height: '1.35rem',
      minWidth: '1.35rem',
      padding: 0,
      borderColor: checked || mixed ? '#58abe2' : '#777',
      backgroundColor: checked || mixed ? '#58abe2' : 'transparent',
      color: checked || mixed ? '#111' : '#f4f4f4',
      cursor: disabled ? 'not-allowed' : 'pointer',
      opacity: disabled ? 0.5 : 1,
      lineHeight: 1
    },
    disabled: disabled,
    title: label,
    'aria-label': label,
    'aria-checked': mixed ? 'mixed' : checked ? 'true' : 'false',
    role: 'checkbox',
    'data-select-all-children': options.selectAll ? true : null,
    'data-bulk-select-rid': options.rid || null,
    onmousedown: function (evt) {
      evt.stopPropagation();
    },
    onclick: function (evt) {
      evt.preventDefault();
      evt.stopPropagation();
      if (!disabled && typeof options.onclick === 'function') {
        options.onclick();
      }
    },
    onkeydown: function (evt) {
      if (evt.key !== 'Enter' && evt.key !== ' ') return;
      evt.preventDefault();
      evt.stopPropagation();
      if (!disabled && typeof options.onclick === 'function') {
        options.onclick();
      }
    }
  }, [
    checked ? m('i.f4.ion-checkmark') : mixed ? m('span.b.f4', '-') : null
  ]);
}

function selectedDeleteLabel(ctrl) {
  var count = selectedChildRecords(ctrl).length;
  if (!count) return 'Delete ' + ctrl.form.name;
  return 'Delete ' + count + ' selected ' + childName(ctrl, count);
}

function selectedCellAttrs(selected) {
  return selected ? { style: { backgroundColor: '#1f4358' } } : {};
}

function deleteErrorMessage(error) {
  if (typeof error === 'string') return error;
  if (error && typeof error.error === 'string') return error.error;
  if (error && typeof error.message === 'string') return error.message;
  return 'Delete failed';
}

function openBulkDeleteDialog(ctrl, records) {
  var recordsToDelete = records.slice();
  var count = recordsToDelete.length;
  var visibleRecords = recordsToDelete.slice(0, 10);

  var submit = function () {
    return recordsToDelete.reduce(function (promise, record) {
      return promise.then(function () {
        return ctrl.form.delete(record);
      });
    }, Promise.resolve())
      .then(function () {
        recordsToDelete.forEach(function (record) {
          delete ctrl.selectedChildRids[recordRid(record)];
        });
        key.unbind('enter');
        modal.vm.close();
        m.redraw();
      })
      .catch(function (error) {
        alerts.vm.add({ detail: deleteErrorMessage(error) });
        m.redraw();
        return Promise.reject(error);
      });
  };

  key.setScope('modal');
  key('enter', 'modal', submit);

  modal.vm.title('Delete ' + count + ' ' + childName(ctrl, count) + '?');
  modal.vm.body = function () {
    return m('div', [
      m('p.mv2', 'This will delete the selected ' + childName(ctrl, count) + '.'),
      m('ul.mv3.pl4', visibleRecords.map(function (record) {
        return m('li', record.name || recordRid(record));
      })),
      count > visibleRecords.length ? m('p.mv2', 'And ' + (count - visibleRecords.length) + ' more.') : null
    ]);
  };
  modal.vm.buttons([
    {
      label: 'Submit',
      class: 'btn-good',
      func: submit
    }
  ]);
  modal.vm.open();
}

function deleteSelectedChildren(ctrl, fallbackRecord) {
  var records = selectedChildRecords(ctrl);
  if (!records.length) {
    return ctrl.form.deleteDialogue(fallbackRecord);
  }
  if (records.length === 1) {
    return ctrl.form.deleteDialogue(records[0]);
  }
  return openBulkDeleteDialog(ctrl, records);
}

function actionDropdown(items) {
  return m(rowActionDropdown, {
    position: 'fixed',
    align: 'left',
    buttonStyle: {
      minWidth: '1.6rem',
      paddingTop: '0.05rem',
      paddingBottom: '0.12rem',
      paddingLeft: '0.18rem',
      paddingRight: '0.18rem',
      lineHeight: '1'
    },
    items: items
  });
}

function childRowActions(ctrl, children) {
  return [
    {
      label: 'Edit ' + ctrl.form.name,
      icon: 'ion-ios-compose',
      onclick: function () { ctrl.form.editDialogue(children, { parentRecord: ctrl.record }); }
    },
    typeof ctrl.form.openResponsePicker === 'function' ? {
      label: 'Create Points',
      icon: 'ion-ios-pulse',
      onclick: function () {
        ctrl.form.openResponsePicker(children, {
          parentRecord: ctrl.record,
          submitCallback: ctrl.init
        });
      }
    } : null,
    {
      label: selectedDeleteLabel(ctrl),
      icon: 'ion-ios-trash',
      class: 'red',
      onclick: function () { deleteSelectedChildren(ctrl, children); }
    }
  ].filter(Boolean);
}

function renderChildNameCell(ctrl, children, url) {
  return m('div.flex.items-center.justify-between', [
    m(m.route.Link, { href: url }, children.name),
    m('div.ml3.flex-none', [
      actionDropdown(childRowActions(ctrl, children))
    ])
  ]);
}

function isBacnetDeviceTable(ctrl) {
  return ctrl.record && ctrl.record['@class'] === 'BacnetServer' &&
    ctrl.form && ctrl.form['@class'] === 'BacnetDevice';
}

function childFields(ctrl) {
  return isBacnetDeviceTable(ctrl) ? BACNET_DEVICE_FIELDS : visibleFormFieldKeys(ctrl.form.fields);
}

function childFieldLabel(ctrl, field) {
  return isBacnetDeviceTable(ctrl) ? BACNET_DEVICE_LABELS[field] || field : field;
}

function renderBacnetSourceAddress(device) {
  var decoded = bacnetPresentation.decodedAddress(device && device.address);
  return decoded || m('span.moon-gray', '—');
}

function renderBacnetAddressBytes(device) {
  var hex = bacnetPresentation.addressHex(device && device.address);
  if (!hex) return m('span.moon-gray', '—');
  return m('span.mono', hex);
}

function renderChildField(ctrl, children, field, url) {
  if (field === 'name') return renderChildNameCell(ctrl, children, url);
  if (!isBacnetDeviceTable(ctrl)) return children[field];
  if (field === 'network') return children.network == null ? 'Direct' : children.network;
  if (field === 'address') return renderBacnetSourceAddress(children);
  if (field === 'addressBytes') return renderBacnetAddressBytes(children);
  if (field === 'segmentation') return bacnetPresentation.segmentationLabel(children.segmentation);
  if (field === 'lastDiscoveredAt') return bacnetPresentation.timestampLabel(children.lastDiscoveredAt);
  if (field === 'vendorId' || field === 'maxApdu') return bacnetPresentation.numericLabel(children[field]);
  return children[field];
}

function browse(ctrl) {
  var fieldsArray = childFields(ctrl);
  var bacnetDevices = isBacnetDeviceTable(ctrl);
  var visibleChildren = selectableChildren(ctrl.childrenToShow);
  var selectedVisibleChildren = visibleSelectedChildren(ctrl);
  var allVisibleSelected = visibleChildren.length > 0 && selectedVisibleChildren.length === visibleChildren.length;
  var someVisibleSelected = selectedVisibleChildren.length > 0 && !allVisibleSelected;
  return m('div.mh3', [
    m(paginationWithSearch, {
      data: ctrl.record.children,
      newNode: ctrl.newNode,
      dataToShow: ctrl.childrenToShow,
      placeHolder: 'Search',
      itemsPerPage: 30,
      fieldsToSearch: bacnetDevices
        ? ['name', 'objectId', 'network', 'address', 'vendorId', 'maxApdu']
        : ['name']
    }, [
      m('div.overflow-hidden', [
        m('div.dragscroll-container', [
          m('div.dragscroll', { oncreate: dragscroll }, [
            m('table.w-100.f4.mb4.pt3.mr4', {
              style: bacnetDevices ? { minWidth: '1280px' } : null
            }, [
              tableColumns.colgroup(tableColumns.withSelection(fieldsArray)),
              m('thead', [
                m('tr', [
                  m('th.ph0.tc', { style: { width: '2.5rem' } }, [
                    renderChildSelectionButton({
                      checked: allVisibleSelected,
                      mixed: someVisibleSelected,
                      disabled: visibleChildren.length === 0,
                      label: 'Select visible ' + childName(ctrl, visibleChildren.length || 2),
                      selectAll: true,
                      onclick: function () {
                        setVisibleChildrenSelected(ctrl, !allVisibleSelected);
                      }
                    })
                  ]),
                  fieldsArray.map(field => {
                    return m('th.ph0.tl', childFieldLabel(ctrl, field))
                  })
                ])

              ]),
              m('tbody', [
                ctrl.childrenToShow.map(children => {
                  if (!children['@rid']) {
                    return m('tr', [
                      m('td.tc.nowrap', [
                        m('div', { style: { visibility: 'hidden' } }, [
                          renderChildSelectionButton({
                            checked: false,
                            disabled: true,
                            label: 'No Data'
                          })
                        ])
                      ]),
                      fieldsArray.map(field => {
                        return m('td.tl.nowrap', [
                          m('label', { style: { 'visibility': 'hidden' } }, 'No Data')
                        ])
                      })
                    ])
                  } else {
                    let url = '/' + children['@id'].split('/').slice(3, 5).join('/').toLowerCase();
                    var selected = isChildSelected(ctrl, children);
                    return m('tr', {
                      'data-child-rid': recordRid(children)
                    }, [
                      m('td.tc.nowrap', selectedCellAttrs(selected), [
                        renderChildSelectionButton({
                          checked: selected,
                          label: 'Select ' + (children.name || ctrl.form.name),
                          rid: recordRid(children),
                          onclick: function () {
                            setChildSelected(ctrl, children, !isChildSelected(ctrl, children));
                          }
                        })
                      ]),
                      fieldsArray.map(field => {
                        return m('td.tl.nowrap', selectedCellAttrs(selected), renderChildField(ctrl, children, field, url))
                      })
                    ])
                  };
                })
              ])
            ])
          ])
        ])
      ])
    ]),
  ])
};

function visibleFormFieldKeys(fields) {
  var keys = [];
  for (const [key, propertyDef] of Object.entries(fields || {})) {
    if (propertyDef.type && !propertyDef.hidden) {
      keys.push(key);
    }
  }
  return keys;
}

function sortByStatus(a, b) {
  if (STATUSES.indexOf(a.status) < STATUSES.indexOf(b.status)) {
    return 1;
  } else if (STATUSES.indexOf(a.status) > STATUSES.indexOf(b.status)) {
    return -1;
  } else {
    return 0;
  }
};

module.exports = page;
